import React from 'react';
import ListButton from '@hubins/components/ListButton';
import Badge from '@hubins/components/Badge';

type Props = {
  signatories: any[],
  beneficialOwners: any[],
  alternativeBeneficialOwners: any[],
  profileId: number,
};

const checkIfPersonnelIsDone = (personnel, profile_id) => {
  return personnel.powers_of_attorney.some((power) => (
    power.profile_id === profile_id
    && power.signed_at
  ));
};

const RenderPersonnel = ({personnel, profileId, role }) => {
  return (
    <>
      {personnel ? personnel.map((item) => {
        const done = checkIfPersonnelIsDone(item, profileId);

        return (
          <div
            key={item.name}
            className="box-padding border flex flex-direction-row align-center space-between"
          >
            <div className='align-left'>
              <p><strong>{item.name}</strong><br />
                {role}
              </p>
            </div>
            <Badge color={done ? 'success' : 'warning'}>
              {done ? 'Genomförd' : 'Ej genomförd'}
            </Badge>
          </div>
        )
      }) : <></>}
    </>
  )
}

const CompanyPersonnelPowersOfAttorney = ({signatories, beneficialOwners, alternativeBeneficialOwners, profileId}: Props) => {

  return (
    <>
      {(signatories.length > 0 || beneficialOwners.length > 0) && (
        <>
          <ListButton
            noBorder
            noIconBorder
            icon={'Multiple Users'}
            title="Status bolagspersoner"
            actionText=''
            text='Samtliga personer nedan behöver signera'
            actionIcon=''
            disabled
          />
          <RenderPersonnel personnel={signatories} profileId={profileId} role="Firmatecknare" />
          <RenderPersonnel personnel={beneficialOwners} profileId={profileId} role="Verklig huvudperson" />
          <RenderPersonnel personnel={alternativeBeneficialOwners} profileId={profileId} role="Alternativ huvudperson" />
        </>
      )}
    </>
  )

};

export default CompanyPersonnelPowersOfAttorney;